"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgMap = function SvgMap(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M1004.7 131.4L684.8 3.5c-6.4-3.2-16-3.2-22.4 0L352 125 44.9 3.5c-9.6-6.4-22.4-3.2-32 3.2C6.5 13.1.1 22.7.1 32.3V864c0 12.8 6.4 25.6 19.2 28.8l319.9 128c3.2 0 6.4 3.2 12.8 3.2 3.2 0 6.4 0 12.8-3.2L672 896l307.1 124.8c3.2 0 6.4 3.2 12.8 3.2s12.8-3.2 19.2-6.4c9.6-6.4 12.8-16 12.8-25.6V160.2c0-12.8-6.4-25.6-19.2-28.8zM320.1 944l-256-102.4V80.3L320 182.7V944zM640 841.6L384 944V182.6L640 80.3v761.3zM959.9 944l-256-102.4V80.3l255.9 102.4V944z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgMap, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;